import React from 'react';
import { localsMessages } from '../../utility/getTemplateData';
import { Button, Text, Tile } from '@paypalcorp/pp-react';
import createAccountIllustrationUrl from './illus_createAccount.svg';

const messages = localsMessages('guest/guestForm');

class CreateAccountTile extends React.Component {
  redirectToOnboarding() {
    const { protocol, hostname } = window.location;

    window.location.href = `${protocol}//${hostname}/ru/webapps/mpp/account-selection`;
  }

  render() {
    const { createAccountTile: { title = '', msg = '', button = '' } = {} } =
      messages || {};

    return (
      <Tile
        card
        className="create_account_tile"
        data-testid="create_account_tile"
      >
        <img src={createAccountIllustrationUrl} className="icon"></img>

        <div className="content">
          <Tile.Header>{title}</Tile.Header>
          <Tile.Content>
            <Text>{msg}</Text>
          </Tile.Content>
          <Tile.Footer>
            <Button
              id="btnToSignUp"
              data-testid="btnToSignUp"
              size="sm"
              as="a"
              onClick={this.redirectToOnboarding}
            >
              {button}
            </Button>
          </Tile.Footer>
        </div>
      </Tile>
    );
  }
}

export default CreateAccountTile;
